import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Estándar de campo de texto del core (foco primary). Es el estándar también
 * dentro de las modales: usar `<Input />`. `INPUT_CLS` se exporta solo para
 * elementos nativos que no son `<input>` (p. ej. `<select>`, `<textarea>`).
 */
/**
 * Borde: `control-border`, el mismo de filtros y selectores (2026-10-28, Eduardo: todos los inputs
 * parejos y lo más suave posible dentro de accesibilidad). Es el mínimo de WCAG 1.4.11 (3:1 contra
 * el fondo): en claro 220 9% 58% da 3.04:1 sobre el fondo de página; en oscuro 215 20% 39% da 3.1:1.
 * Más claro deja de cumplir.
 */
export const INPUT_CLS =
  "flex h-10 w-full rounded-md border border-control-border bg-background px-3 py-2.5 text-base font-medium ring-offset-background transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:font-normal placeholder:text-foreground/40 focus-visible:border-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/15 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-50 md:text-sm";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return <input type={type} className={cn(INPUT_CLS, className)} ref={ref} {...props} />;
  },
);
Input.displayName = "Input";

export { Input };
